import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogTitle,
  AlertDialogDescription,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/Button';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSaveAndImport: () => void;
  onImportWithoutSave: () => void;
}

export function SavePresetDialog({
  open,
  onOpenChange,
  onSaveAndImport,
  onImportWithoutSave,
}: Props) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="w-[640px] max-w-screen-sm p-0">
        {/* ヘッダー */}
        <div className="flex items-center justify-between border-b border-solid border-border px-lg py-md">
          <AlertDialogTitle className="text-heading-xs">
            未保存の取り込みプリセットです
          </AlertDialogTitle>
        </div>

        {/* 本文 */}
        <div className="p-lg">
          <AlertDialogDescription className="text-foreground text-body-sm">
            この取り込みプリセットを保存しますか？
          </AlertDialogDescription>
        </div>

        {/* フッター */}
        <div className="flex justify-end gap-md border-t border-solid border-border px-lg py-md">
          <Button color="secondary" size="md" type="button" onClick={onImportWithoutSave}>
            保存せずに取り込み
          </Button>
          <Button color="primary" size="md" type="button" onClick={onSaveAndImport}>
            保存して取り込み
          </Button>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
}
